import { render, staticRenderFns } from "./createInvoice.vue?vue&type=template&id=578624c2&scoped=true&"
import script from "./createInvoice.vue?vue&type=script&lang=js&"
export * from "./createInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578624c2",
  null
  
)

export default component.exports